export const listSchedules = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/schedule/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return null;
  }
  return JSON.parse(response.payload);
};
